import React from "react";

export const PlusSignSvg = (props) => {
  const { width, height, color, withoutBox, bordered } = props;

  if (bordered) {
    return (
      <svg width={width ?? "157"} height={height ?? "96"} viewBox="0 0 157 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_5481_16383)">
          <rect x="2" y="1" width="110" height="89" rx="12" fill="white" />
          <rect x="2.5" y="1.5" width="109" height="88" rx="11.5" stroke="#E3E3E3" />
        </g>
        <path d="M57.4968 40.1406V51.7342" stroke={window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M51.957 45.9375H63.0367" stroke={window?.settings?.primary_color ?? '#1DBD6B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
          <filter id="filter0_d_5481_16383" x="0" y="0" width="114" height="93" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5481_16383" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5481_16383" result="shape" />
          </filter>
        </defs>
      </svg>

    )
  }

  if (withoutBox) {
    return (
      <svg
        width={width ?? "12"}
        height={height ?? "12"}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00153 1V11"
          stroke={color ?? window?.settings?.secondary_color ?? '#04333b'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0095 5.99945H1"
          stroke={color ?? window?.settings?.secondary_color ?? '#04333b'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width ?? "14"}
      height={height ?? "14"}
      viewBox="0 0 14 14"
      fill={color ?? window?.settings?.primary_color ?? '#1DBD6B'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.11301 0.332764H9.89301C12.153 0.332764 13.6663 1.91943 13.6663 4.27943V9.72676C13.6663 12.0801 12.153 13.6661 9.89301 13.6661H4.11301C1.85301 13.6661 0.333008 12.0801 0.333008 9.72676V4.27943C0.333008 1.91943 1.85301 0.332764 4.11301 0.332764ZM6.99788 9.83234C7.31796 9.83281 7.57724 9.57354 7.57724 9.25298V7.57478L9.25591 7.57431C9.57599 7.57478 9.83998 7.3108 9.83998 6.99024C9.84045 6.66921 9.58118 6.40994 9.25544 6.4057L7.58242 6.40994L7.58195 4.73221C7.57771 4.40647 7.31843 4.1472 6.99741 4.14767C6.67685 4.14767 6.41287 4.41166 6.41334 4.73174L6.41287 6.41041L4.73938 6.4057C4.41411 6.41041 4.15484 6.66969 4.15531 6.98977C4.15531 7.15005 4.22083 7.30137 4.32454 7.40508C4.43297 7.5135 4.57957 7.57431 4.73985 7.57431L6.41287 7.5795L6.41805 9.25251C6.41287 9.41798 6.47886 9.5594 6.58257 9.66311C6.69099 9.77153 6.8376 9.83234 6.99788 9.83234Z"
      />
    </svg>
  );
};
